export function getAddButtonWrappersInBounds(bounds: DOMRect): HTMLElement[] {
  const wrappers = Array.from(
    document.querySelectorAll<HTMLElement>('[class*="AddButton__AddButtonWrapper"]')
  );
  return wrappers.filter((wrapper) => {
    const rect = wrapper.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    return cx >= bounds.left && cx <= bounds.right && cy >= bounds.top && cy <= bounds.bottom;
  });
}

export function setAddButtonsVisible(visible: boolean): void {
  const targetDoc = window.parent?.document || window.top?.document || document;
  const allDivs = targetDoc.getElementsByTagName("div");
  for (let i = 0; i < allDivs.length; i++) {
    const div = allDivs[i];
    const classAttr = div.getAttribute("class");
    if (classAttr && classAttr.includes("AddButton__AddButtonWrapper")) {
      div.style.display = visible ? "" : "none";
    }
  }
}

